import { render, staticRenderFns } from "./Inscriptions-otros-conceptos-comp.vue?vue&type=template&id=24b9b2b3&scoped=true&"
import script from "./Inscriptions-otros-conceptos-comp.vue?vue&type=script&lang=js&"
export * from "./Inscriptions-otros-conceptos-comp.vue?vue&type=script&lang=js&"
import style0 from "./Inscriptions-otros-conceptos-comp.vue?vue&type=style&index=0&id=24b9b2b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b9b2b3",
  null
  
)

export default component.exports